import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useResetPassword } from '@/features/auth/hooks/useResetPassword';

export const CheckEmailPage = () => {
    const location = useLocation();
    const email = new URLSearchParams(location.search).get('email') || 'указанный вами адрес';

    const { resetPassword, loading, error } = useResetPassword();
    const [resent, setResent] = useState(false);

    const handleResend = async () => {
        const ok = await resetPassword(email);
        setResent(true);
    };

    return (
        <main className="layout__content">
            <section className="section layout__section auth">
                <div className="container">
                    <div className="auth__block auth-block" style={{ textAlign: 'center' }}>
                        <header className="auth-block__header">
                            <h1 className="title auth-block__title">Проверьте почту</h1>
                        </header>

                        <div className="auth-block__content">
                            <p className="auth-form__hint-text" style={{ marginBottom: 20 }}>
                                Мы отправили письмо с инструкцией по восстановлению пароля на <b className="emailCheck">{email}</b>.
                                Иногда письмо может попасть в папку <b>«Спам»</b>.
                            </p>

                            <div style={{ margin: '30px auto' }}>
                                <svg width="118" height="118" viewBox="0 0 118 118" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="59" cy="59" r="58.5" stroke="#D3D3D3" strokeDasharray="5 5" />
                                    <circle cx="59" cy="59" r="49.5" fill="white" stroke="#DDDDDD" />
                                    <circle cx="59" cy="59" r="50" fill="#E2EF4A" />
                                    <path d="M52.875 74L38.625 59.75L42.1875 56.1875L52.875 66.875L75.8125 43.9375L79.375 47.5L52.875 74Z" fill="#277871" />
                                </svg>
                            </div>

                            {error && (
                                <div style={{ color: '#EA3323', marginTop: 12, fontWeight: 500 }}>
                                    Не удалось повторно отправить письмо. Попробуйте позже.
                                </div>
                            )}

                            <div style={{ marginTop: 24 }}>
                                {!resent ? (
                                    <p style={{ marginBottom: 12 }}>
                                        Не видите письмо?{' '}
                                        <button
                                            type="button"
                                            onClick={handleResend}
                                            className="form__link"
                                            disabled={loading}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                padding: 0,
                                                margin: 0,
                                                font: 'inherit',
                                                color: 'inherit',
                                                cursor: 'pointer',
                                                textDecoration: 'underline'
                                            }}
                                        >
                                            {loading ? 'Отправка...' : 'Повторить отправку'}
                                        </button>
                                    </p>
                                ) : (
                                    <p className="auth-form__hint-text" style={{ marginBottom: 12 }}>
                                        Если вы не получили письмо в течение нескольких минут, вы можете повторить попытку
                                        или указать другой адрес.{' '}
                                        <button
                                            type="button"
                                            onClick={handleResend}
                                            className="form__link"
                                            disabled={loading}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                padding: 0,
                                                margin: 0,
                                                font: 'inherit',
                                                color: 'inherit',
                                                cursor: 'pointer',
                                                textDecoration: 'underline'
                                            }}
                                        >
                                            {loading ? 'Отправка...' : 'Повторить отправку'}
                                        </button>
                                    </p>
                                )}

                                <p>
                                    <Link to="/login" className="form__link">
                                        Вернуться на страницу входа
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};
